/**
 * @generated SignedSource<<dac456cf705cdbfdb991f33b7d13eb42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pAccountId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountName",
        "variableName": "accountName"
      },
      {
        "kind": "Variable",
        "name": "endTs",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "pAccountId",
        "variableName": "pAccountId"
      },
      {
        "kind": "Variable",
        "name": "startTs",
        "variableName": "startDate"
      },
      {
        "kind": "Variable",
        "name": "vendorAccountId",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "VendorResellerBindCardChargeWSum2SConnection",
    "kind": "LinkedField",
    "name": "getvendorresellerbindcardchargeswithsummary2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VendorResellerBindCardChargeWSum2",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcChargeSum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rebateSum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAppStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appLogo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bindCardCharge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rebate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorTransactionsFetchQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorTransactionsFetchQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "02ac4251862b85339ad9181638ad69a9",
    "id": null,
    "metadata": {},
    "name": "VendorTransactionsFetchQuery",
    "operationKind": "query",
    "text": "query VendorTransactionsFetchQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountName: String\n  $pAccountId: UUID\n  $vendorAccountId: UUID\n  $first: Int\n  $offset: Int\n) {\n  getvendorresellerbindcardchargeswithsummary2(startTs: $startDate, endTs: $endDate, accountName: $accountName, pAccountId: $pAccountId, vendorAccountId: $vendorAccountId, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      bcChargeSum\n      rebateSum\n      customerAccountName\n      customerAppStatus\n      appId\n      appName\n      appLogo\n      transactionId\n      transactionTime\n      bindCardCharge\n      rebate\n    }\n  }\n}\n"
  }
};
})();

node.hash = "233422d323bfdeefddac7092854b6c06";

module.exports = node;
